import { NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { Injectable } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";

@Injectable({ providedIn: 'root' })
export class CustomNgbDatepickerI18n extends NgbDatepickerI18n {
  constructor(private translocoService: TranslocoService) {
    super();
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return "";
  }

  getMonthFullName(month: number): string {
    return this.translateMonth('months.picker', month);
  }

  getMonthShortName(month: number): string {
    return this.translateMonth('months.picker.short', month);
  }

  getWeekdayLabel(weekday: number): string {
    return this.translocoService.translate(`days.of.the.week.picker.${['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'][weekday - 1]}`);
  }

  private translateMonth(prefix: string, month: number): string {
    return this.translocoService.translate(`${prefix}.${['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'][month - 1]}`);
  }
}

@Injectable()
export class CustomNgbDatepickerAdapter extends NgbDateAdapter<Date> {
  fromModel(value: Date | null): NgbDateStruct | null {
    return value && this.isValidDate(value) ? { day: value.getDate(), month: value.getMonth() + 1, year: value.getFullYear() } : null;
  }

  toModel(date: NgbDateStruct | null): Date | null {
    return date ? new Date(date.year, date.month - 1, date.day) : null;
  }

  isValidDate(date: any): boolean {
    return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
  }
}

@Injectable()
export class CustomNgbDatepickerDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER_SLASH = '/';
  readonly DELIMITER_DOT = '.';

  constructor(private translocoService: TranslocoService) {
    super();
  }

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const [day, month, year] = value.split(this.getDelimiter()).map(Number);
      return { day, month, year };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? `${date.day}${this.getDelimiter()}${date.month}${this.getDelimiter()}${date.year}` : '';
  }

  getDelimiter(): string {
    return ['hr', 'slo'].includes(this.translocoService.getActiveLang()) ? this.DELIMITER_DOT : this.DELIMITER_SLASH;
  }
}
